import React from "react"

import LockingSystemPermission from "../../types/LockingSystemPermission"
import ViewHeader              from "./View/Header"
import ViewItemGroupInfo       from "./View/ItemGroupInfo"
import ViewItemGroupLinked     from "./View/ItemGroupLinked"

export interface props {
    item: LockingSystemPermission
}

const View: React.FC<props> = ({ item }) => {

    return (
        <div className="ion-text-center">
            <ViewHeader          item={item} />
            <ViewItemGroupInfo   item={item} />
            <ViewItemGroupLinked item={item} />
        </div>
    )

}

export default View